import React from 'react';

import { getReadableFileSize } from '@neptune/shared/common-util';

import { PropertyRow } from 'components/layouts/rows';
import type { IntegerAttribute } from 'domain/experiment/attribute';

type SizeRendererProps = {
  attribute?: IntegerAttribute;
  labelWidth?: string;
  label?: string;
  'data-name'?: string;
  rowVariant?: 'compact' | 'default';
};

export const SizeRenderer: React.FC<SizeRendererProps> = ({
  attribute,
  labelWidth = '100px',
  label,
  'data-name': dataName,
  rowVariant = 'default',
}) => {
  if (!attribute) {
    return null;
  }

  const size = attribute.value;

  return (
    <PropertyRow
      value={getReadableFileSize(size)}
      labelWidth={labelWidth}
      label={label}
      data-name={dataName}
      variant={rowVariant}
    />
  );
};
